export default "__VITE_ASSET__CHYilUbV__"